import { sfwUrl } from "./env";
import { routes } from "@/common/utils/routes";
import { loadRedditAppVisit } from "@/common/utils/storage";
import { getDeviceType, deviceTypeEnum, getWindowWidth } from "@/common/utils/device";
import { IGeolocation } from "@/common/services/types";

const COMMON_ALLOWED_PAGES = [
  "/auth/signin",
  "/ifr/",
  "/user/verify",
  "/experiments",
];

export const AGE_VERIFICATION_COUNTRIES = ["GB"];

export const isPageAllowed = (pathname: string, location: IGeolocation | null): boolean => {
  const isMobile = getDeviceType(getWindowWidth()) === deviceTypeEnum.PHONE;

  if (loadRedditAppVisit() && isMobile && AGE_VERIFICATION_COUNTRIES.includes(location?.country || "")) {
    return true; // Reddit app users from countries with mandatory age verification can access all pages
  }

  if (COMMON_ALLOWED_PAGES.some((page) => pathname.startsWith(page))) {
    return true; // Common pages e.g. guidelines are always allowed
  }

  if (location === null) {
    return false; // Geolocation not determined yet, block by default
  }

  const statePage = location.state ? routes.geoBlockedPage(location.state) : "";

  if (statePage && pathname.startsWith(statePage)) {
    return true; // User is on the specific geo-blocked page for their state
  }

  return !location.blocked;
};

export const getAlternatePage = (pathname: string, location: IGeolocation | null): string | null => {
  if (!isPageAllowed(pathname, location)) {
    if (location?.state) {
      return routes.geoBlockedPage(location.state);
    }

    if (AGE_VERIFICATION_COUNTRIES.includes(location?.country || "")) {
      return sfwUrl;
    }
  }

  return null;
};
